// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1GE_U","choiceBoxes":"toolbarselects_choiceBoxes__1g5S4","simpleField":"toolbarselects_simpleField__1iUfz"};